module.exports = __webpack_public_path__ + "media/images/send_mail-bf5fb0ff81d8c5bb15fda938ff457c61.png";